import { Pipe, PipeTransform } from '@angular/core';
import { async } from '@angular/core/testing';

@Pipe({
  name: 'removeSplChar'
})
export class RemoveSplCharPipe implements PipeTransform {

  transform(value: any, ...args: any[]) {
    let letter = this.removeSplChar(value)
    let str = letter.split(" ");
    for (var i = 0, x = str.length; i < x; i++) {
      str[i] = str[i][0].toUpperCase() + str[i].substr(1);
    }
    return str.join(" ");
  }

  removeSplChar(value) {
    // let regExp = /[^Ä Å« ä å« ]/g;
    let match1 = 'Ä';
    let match2 = 'Å«';
    let match3 = 'ä';
    let match4 = 'å«';
    let match5 = 'Ä«';
    let match6 = 'Ä€';
    let match7 = 'Åª';
    if (value.includes(match1) || value.includes(match2) || value.includes(match3) || value.includes(match4) || value.includes(match5) || value.includes(match6) || value.includes(match7)) {
      let letters11 = value.replace("Ä", 'a');
      let letters12 = letters11.replace("Ä", 'a');
      let letters13 = letters12.replace("Ä", 'a');
      let letters14 = letters13.replace("Ä", 'a');
      let letters15 = letters14.replace("Ä", 'a');
      let letters21 = letters15.replace("Å«", 'u');
      let letters22 = letters21.replace("Å«", 'u');
      let letters23 = letters22.replace("Å«", 'u');
      let letters24 = letters23.replace("Å«", 'u');
      let letters25 = letters24.replace("Å«", 'u');
      let letters31 = letters25.replace("ä", 'a');
      let letters32 = letters31.replace("ä", 'a');
      let letters33 = letters32.replace("ä", 'a');
      let letters34 = letters33.replace("ä", 'a');
      let letters35 = letters34.replace("ä", 'a');
      let letters41 = letters35.replace("å«", 'u');
      let letters42 = letters41.replace("å«", 'u');
      let letters43 = letters42.replace("å«", 'u');
      let letters44 = letters43.replace("å«", 'u');
      let letters45 = letters44.replace("å«", 'u');
      let letters51 = letters45.replace("Ä«", 'a');
      let letters52 = letters51.replace("Ä«", 'a');
      let letters53 = letters52.replace("Ä«", 'a');
      let letters54 = letters53.replace("Ä«", 'a');
      let letters55 = letters54.replace("Ä«", 'a');
      let letters61 = letters55.replace("Ä€", 'a');
      let letters62 = letters61.replace("Ä€", 'a');
      let letters63 = letters62.replace("Ä€", 'a');
      let letters71 = letters63.replace("Åª", 'a');
      let letters72 = letters71.replace("Åª", 'a');
      let letters73 = letters72.replace("Åª", 'a');
      let finalMatch = letters73

      return finalMatch

    } else {
      return value
    }
  }

}
